// extracted by mini-css-extract-plugin
export default {"link":"n6tJMBh7WimgHT_r8u9m","name":"ERiQHr1wvZYV6UVExrok","trunc":"Cy1t4HzKDMVghSgESgBa","icon":"eKgcrPOfzVbZdLy76JzM"};